export class TypeTiers {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}


export class TypeTiersForm {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}